import { Heading } from 'components/Heading';
import { DocumentAdd, Suport } from 'components/Icons';

import * as S from './styles';

import { useEffect, useState } from 'react';
import { api } from 'services/api';
import { Loading } from 'components/Loading';
import moment from 'moment';
import 'moment/locale/pt-br';
import { MainHeader } from 'components/MainHeader';
import { BaseMain } from 'components/BaseMain';

import SubHeader from 'components/SubHeader/SubHeader';
import { useCustomUtilsHistory } from 'services/react-router-custom-history';
import { InvoiceStatus } from 'components/InvoiceStatus';
import { BaseContentMain } from 'components/BaseContentMain';
import { formatCurrency } from 'pages/PlanDetails';
import { buildPlanPrice } from 'helpers/util';

export type DataProps = {
  totalCost: string;
  discountValue: string;
  installmentAmount: number;
  totalUserCount: number;
  maxUserCount: number;
  frequency: string;
  startTrialDate: string;
  activationDate: string;
  terminationDate: string;
  id_client: string;
  name: string;
  typeProduct: string;
  totalLeasingContractCount: string;
  finalValue: string;
};

export type PlanDetailsProps = {
  activationDate: string;
  totalUserCount: number;
  maxUserCount: number;
  totalUserExtra: number;
  costUserExtra: number | undefined;
  totalCostUserExtra: number | undefined;
  frequency: string;
  startTrialDate: string;
  terminationDate: string;
  name: string;
  id_plan: number;
  id_client: string;
  plan: {
    name: string;
  };
  status: string;
  typeProduct: string;
  totalLeasingContractCount: string;
};

export type PlanDetailsValuesProps = {
  activationDate: string;
  terminationDate: string;
  additionalUserCost: string;
  frequency: string;
  totalCost: string;
  discountValue: string;
  finalValue: string;
  installmentAmount: number;
  installmentValue: string;
  status: string;
  typeProduct: string;
  type_payment: {
    description: string;
  };
};

export const KenloLocation = () => {
  const [isMobile, setIsMobile] = useState(false);

  const history = useCustomUtilsHistory();
  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  const [isLoading, setIsLoading] = useState(false);
  const [infor, setInfor] = useState<any>({});
  const [inforSignature, setInforSignature] = useState<any>({});

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 800);
    };

    // Verificar no carregamento
    checkMobile();

    // Adicionar event listener para mudanças de largura
    window.addEventListener('resize', checkMobile);

    // Limpar event listener
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  // const { id } = useParams<{ id: string }>();

  // const accessToken = localStorage.getItem('accessToken');
  // const idToken = localStorage.getItem('idToken');

  // const safeCount = (count: any) => count ?? 0;
  // const pluralize = (count: any, word: any) => {
  //   return count > 1 ? `${word}s` : word;
  // };
  // const pluralizeSubTitle = (count: any, word: any) => {
  //   return count > 1 ? `não acessaram nest${word}` : `não acessou nest${word}`;
  // };
  // const d = 0;
  // const infors = [
  //   {
  //     icon: <PersonClockRed />,
  //     title:
  //       safeCount(0) > 0 ? `${0} ${pluralize(0, 'usuário')}` : 'Nenhum usuário',
  //     subTitle: `${pluralizeSubTitle(safeCount(0), 'a semana')}`,
  //   },
  //   {
  //     icon: <PersonPrivate />,
  //     title:
  //       safeCount(0) > 0 ? `${0} ${pluralize(0, 'usuário')}` : 'Nenhum usuário',
  //     subTitle: `${pluralizeSubTitle(safeCount(0), 'e mês')}`,
  //   },
  //   {
  //     icon: <PersonBlock />,
  //     title:
  //       safeCount(0) > 0 ? `${0} ${pluralize(0, 'usuário')}` : 'Nenhum usuário',
  //     subTitle: `${
  //       d > 1 ? 'nunca acessaram o sistema' : 'nunca acessou o sistema'
  //     }`,
  //   },
  // ];
  useEffect(() => {
    const fetchComplementaryProducts = async () => {
      setIsLoading(true);
      try {
        const { data } = await api.get('products', {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        });
        setInfor(data.data.find((el: any) => el.id === 2));
      } catch (error) {
        console.log(error);
      }
      setIsLoading(false);
    };
    fetchComplementaryProducts();
  }, [accessToken, idToken]);
  useEffect(() => {
    const fetchDataSignatures = async () => {
      try {
        const { data } = await api.get(
          `client/signatures/${infor?.id_signature}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setInforSignature(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    infor?.id_signature && fetchDataSignatures();
  }, [accessToken, idToken, infor?.id_signature]);

  const planPrice = buildPlanPrice(
    infor?.planFrequency,
    infor?.installmentValue,
    inforSignature,
  );

  return (
    <>
      <MainHeader />
      <SubHeader
        title="Detalhes do Produto"
        onReturn={() => history.push('/ClientArea')}
      />
      {isLoading && <Loading />}
      <BaseMain hideHeader>
        <S.BodyContentWrapper>
          <S.WrapperAside>
            <S.contentAside>
              <S.TitleAside>
                <span className="title">Kenlo Locação</span>
                <InvoiceStatus
                  status={infor?.status === 'ativo' ? 'paga' : 'cancelada'}
                  text={infor?.status === 'ativo' ? 'Ativo' : 'Suspenso'}
                />
              </S.TitleAside>
              <S.TitleAside>
                <S.TextAside>Total de contratos</S.TextAside>
                <span className="title">
                  {inforSignature?.totalLeasingContractCount || 0}
                </span>
              </S.TitleAside>
              <hr
                style={{
                  marginLeft: '-24px',
                  marginRight: '-24px',
                  marginBottom: '24px',
                }}
              />
              <S.TitleAside>
                <S.TextAside fontWeight="700">Cobrança</S.TextAside>
              </S.TitleAside>
              <S.Grid>
                <div>
                  <S.TextAside fontSize="12" color="#808080">
                    Data de contratação
                  </S.TextAside>
                  <S.TextAside>
                    {moment(infor?.activationDate).format('DD/MM/YYYY')}
                  </S.TextAside>
                </div>
                <div>
                  <S.TextAside fontSize="12" color="#808080">
                    Data de renovação
                  </S.TextAside>
                  <S.TextAside>
                    {moment(inforSignature?.terminationDate)
                      .startOf('month')
                      .format('D[º] [de] MMMM [de] YYYY')}
                  </S.TextAside>
                </div>
              </S.Grid>

              <div>
                <S.TextAside fontSize="12" color="#808080">
                  Valor
                </S.TextAside>
                <S.TextAside fontSize="20">
                  {formatCurrency(planPrice.value) || '0,00'}
                  {planPrice.period ? ` / ${planPrice.period}` : ''}
                </S.TextAside>
              </div>
            </S.contentAside>
          </S.WrapperAside>
          <S.WrapperMain>
            {/* <S.contentAside>
              <S.TitleAside>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '16px' }}
                >
                  <S.Circle percentage={`${percentage}`}>
                    {percentage === 100 && <CheckMarkLinear />}
                  </S.Circle>

                  <div>
                    <S.TextAside fontSize="32" fontWeight="700">
                      usuários
                    </S.TextAside>
                    <S.TextAside fontSize="16" color="#808080">
                      acessaram nos útimos 7 dias
                    </S.TextAside>
                  </div>
                </div>
                {!isMobile && (
                  <S.TextAside
                    fontSize="16"
                    color="#298ee6"
                    cursor
                    onClick={() =>
                      window.open(
                        `${imobUrl}/admin/default.aspx#/new-digital-rent`,
                        '_blank',
                      )
                    }
                  >
                    Gerenciar
                  </S.TextAside>
                )}
              </S.TitleAside>
              <hr style={{ margin: ' 0 -24px ' }} />
              <S.GridInfos>
                {infors.map((el, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                    }}
                  >
                    {el.icon}
                    <div>
                      <S.TextAside fontSize="16" fontWeight="700">
                        {el.title}
                      </S.TextAside>
                      <S.TextAside fontSize="12" color="#808080">
                        {el.subTitle}
                      </S.TextAside>
                    </div>
                  </div>
                ))}
              </S.GridInfos>
            </S.contentAside> */}
            <BaseContentMain
              padding="2.4rem 2.4rem 2.4rem 2.4rem"
              title={
                <S.WrapperTitle>
                  <Heading
                    title="Serviços adicionais"
                    weight="600"
                    size="large"
                    color="#1A1A1A"
                  />
                </S.WrapperTitle>
              }
            >
              <>
                <div
                  style={{
                    padding: '16px',
                    border: '1px solid #D8D8D8',
                    borderRadius: '12px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      marginBottom: '8px',
                    }}
                  >
                    <DocumentAdd />
                    <S.TextAside fontSize="16" fontWeight="700">
                      Contratos
                    </S.TextAside>
                  </div>
                  <div>
                    <S.TextCustom
                      fontSize="16"
                      fontWeight="500"
                      color=" #808080"
                    >
                      Entre em contato através da{' '}
                      <S.TextCustom
                        fontSize="16"
                        fontWeight="700"
                        color="#298ee6"
                        cursor
                        onClick={() => window.fcWidget.open()}
                      >
                        área de suporte
                      </S.TextCustom>{' '}
                      e clique em “Minha Assinatura Kenlo” para solicitar
                      contratos adicionais ao seu plano.
                    </S.TextCustom>
                  </div>
                </div>
              </>
            </BaseContentMain>
            <S.contentAside>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '24px',
                  flexDirection: isMobile ? 'column' : 'row',
                }}
              >
                <Suport />
                <div>
                  <S.TextAside fontSize="16" fontWeight="700">
                    Tire suas dúvidas do Kenlo Locação
                  </S.TextAside>
                  <S.TextCustom fontSize="16" fontWeight="500" color=" #808080">
                    Você pode{' '}
                    <S.TextCustom
                      fontSize="16"
                      fontWeight="700"
                      color="#298ee6"
                      cursor
                      onClick={() => window.fcWidget.open()}
                    >
                      entrar em contato
                    </S.TextCustom>{' '}
                    pelo balão flutuante em qualquer lugar do sistema ou
                    verificar se já tem resposta para sua dúvida na
                    <S.TextCustom
                      fontSize="16"
                      fontWeight="700"
                      color="#298ee6"
                      cursor
                      onClick={() =>
                        window.open(
                          `https://fresh.kenlo.com.br/support/solutions/156000087291`,
                          '_blank',
                        )
                      }
                    >
                      {' '}
                      base de conhecimento.
                    </S.TextCustom>
                  </S.TextCustom>
                </div>
              </div>
            </S.contentAside>
          </S.WrapperMain>
        </S.BodyContentWrapper>
      </BaseMain>
    </>
  );
};
